import { useState } from "react";
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";

import lock_img from '../../assets/images/locker.svg'
import { Link } from "react-router-dom";
import { selectBlockAppMessage } from "../../services/global/globalSlice";


const Container = styled.div`
        display: flex;
        jsutify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: #37373780;
        z-index: 1000;
        backdrop-filter: blur(10px);
    `;

export default function BlockedScreen ({children}) {

    const t = useSelector(selectTranslations)

    return(
        <Container id="blockedScreen">
            <Modal
                show={true}
                keyboard={false}
                centered
            >
            <Modal.Body>
                    <img src={lock_img} className="mx-auto d-block"  />
                    <h2 className="text-center mt-3">{t.demo.modals.expired_title}</h2>
                    <p className="text-center mb-4">{t.demo.modals.expired_text}</p>
                    <Link to={"/demo/upgrade"}>
                        <button className="d-block w-100 mx-auto">{t.demo.modals.expired_cta}</button>
                    </Link>
                </Modal.Body>
            </Modal>
        </Container>
    )
}
